/**
 * Extrait les initiales d'un nom
 * @param {string} name - Le nom complet de l'utilisateur
 * @returns {string} Les initiales (2 lettres) ou "?" si le nom est vide
 */
export const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

/**
 * Retourne le nom sans le dernier mot (prénom sans nom de famille)
 * @param {string} name - Le nom complet de l'utilisateur
 * @returns {string} Le nom sans le dernier mot
 */
export const getName = (name) => {
  if (!name) return '';
  return name.split(' ').slice(0, -1).join(' ');
};

